import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { environment } from '@environments/environment';
import { BookingService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as fromStore from '../../../../store';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { extendMoment } from 'moment-range';
import { Router } from '@angular/router';
var moment = extendMoment(Moment);
var StopoverComponent = /** @class */ (function () {
    function StopoverComponent(router, fb, sidebarService, bookingService, store) {
        var _this = this;
        this.router = router;
        this.fb = fb;
        this.sidebarService = sidebarService;
        this.bookingService = bookingService;
        this.store = store;
        this.hasSelectedRoute = true;
        this.isEligibleRoute = true;
        this.isLoading = true;
        this.isAlive = true;
        this.triedToSubmit = false;
        this.labels = { departure: 'Departure', arrival: 'Arrival' };
        this.stopovers$ = this.store.select(fromStore.getMiniIBEStopovers);
        this.stopovers = new BehaviorSubject([]);
        this.searchRoutes$ = this.store.select(fromStore.getMiniIBESearchRoutes);
        this.searchRoutes = [];
        this.routeType$ = this.store.select(fromStore.getMiniIBERouteType);
        this.hasChanges$ = combineLatest(this.searchRoutes$, this.stopovers$, this.routeType$);
        this.disableSince = '';
        this.disableUntil = '';
        this.markDates = '';
        this.form = this.fb.group({
            searchroute: this.fb.array([]),
            stopover: this.fb.array([])
        });
        moment.locale(environment.locale);
        this.form.valueChanges.subscribe(function (value) {
            _this.triedToSubmit = false;
        });
    }
    StopoverComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hasChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var searchRoutes = _a[0], stopovers = _a[1], routeType = _a[2];
            if (searchRoutes) {
                if (searchRoutes[0].departure && searchRoutes[0].arrival) {
                    searchRoutes = searchRoutes.filter(function (cur) { return cur.arrival && cur.departure; });
                    _this.searchRoutes = searchRoutes;
                    _this.labels.departure = searchRoutes[0].departure.code + " - " + searchRoutes[0].arrival.code;
                    _this.labels.arrival = searchRoutes[0].arrival.code + " - " + searchRoutes[0].departure.code;
                    var countrys = searchRoutes.map(function (cur) { return ({ departure: cur.departure.code, arrival: cur.arrival.code }); });
                    if (!countrys.length) {
                        _this.hasSelectedRoute = false;
                        _this.isEligibleRoute = true;
                        _this.isLoading = false;
                    }
                    else {
                        _this.TAP_getStopovers({
                            searchRoutes: searchRoutes,
                            stopovers: stopovers || false,
                            routeType: routeType || false,
                        });
                    }
                }
                else {
                    _this.isLoading = false;
                    _this.hasSelectedRoute = false;
                }
            }
        });
        this.disableUntil = { year: moment().format('YYYY'), month: moment().format('M'), day: moment().subtract(1, 'days').format('D') };
        // this.disableSince = { year: moment().year(), month: moment().month(), day: moment().day() };
    };
    StopoverComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    StopoverComponent.prototype.TAP_departureDatepickerOptions = function (dateArrival) {
        var disableUntil = { year: moment().format('YYYY'), month: moment().format('M'), day: moment().subtract(1, 'days').format('D') };
        var since = moment().add(366, 'days');
        var disableSince = { year: since.format('YYYY'), month: since.format('M'), day: since.format('D') };
        if (dateArrival) {
            var arrival = moment(dateArrival, 'DD/MM/YYYY');
            disableSince = { year: arrival.format('YYYY'), month: arrival.format('M'), day: arrival.format('D') };
        }
        var result = { disableUntil: disableUntil, disableSince: disableSince };
        return result;
    };
    StopoverComponent.prototype.TAP_arrivalDatepickerOptions = function (dateDeparture) {
        var since = moment().add(366, 'days');
        var disableSince = { year: since.format('YYYY'), month: since.format('M'), day: since.format('D') };
        var result = { disableSince: disableSince };
        if (dateDeparture) {
            var departure = moment(dateDeparture, 'DD/MM/YYYY');
            var disableUntil = { year: departure.format('YYYY'), month: departure.format('M'), day: departure.format('D') };
            result['disableUntil'] = disableUntil;
        }
        return result;
    };
    /**
     * Create form controls with initial values and restrictions
     */
    StopoverComponent.prototype.createForm = function (stopovers, searchroutes, dataFilled, route_type) {
        var _this = this;
        if (dataFilled === void 0) { dataFilled = false; }
        this.route_type = route_type;
        var searchRoutes = searchroutes.map(function (stopover) {
            if (route_type == 'one way') {
                return _this.fb.group({
                    departure: [stopover.departure && stopover.departure.date ? moment(stopover.departure.date).format('DD/MM/YYYY') : null, Validators.required]
                });
            }
            else if (route_type == 'multicity') {
                return _this.fb.group({
                    departure: [stopover.departure && stopover.date ? moment(stopover.date).format('DD/MM/YYYY') : null, Validators.required]
                });
            }
            else {
                return _this.fb.group({
                    departure: [stopover.departure && stopover.departure.date ? moment(stopover.departure.date).format('DD/MM/YYYY') : null, Validators.required],
                    arrival: [stopover.arrival && stopover.arrival.date ? moment(stopover.arrival.date).format('DD/MM/YYYY') : null, Validators.required],
                });
            }
        });
        this.form = this.fb.group({
            searchroute: this.fb.array(searchRoutes),
            stopover: this.fb.array(stopovers.map(function (stopover) {
                return _this.fb.group({
                    active: [false],
                    country: [stopover.country],
                    city: [null],
                    when: [null],
                    days: [null],
                    id: [stopover.id],
                });
            })),
        });
        if (dataFilled) {
            var _loop_1 = function (stopover) {
                var indexStopover = void 0;
                if (this_1.route_type == 'multicity') {
                    indexStopover = this_1.form.get('stopover').value.findIndex(function (el) { return el.id == stopover.id; });
                }
                else {
                    indexStopover = this_1.form.get('stopover').value.findIndex(function (el) { return el.country == stopover.country; });
                }
                this_1.form.get('stopover').at(indexStopover).setValue(stopover);
                this_1.form.get('stopover').at(indexStopover).get('active').setValue(true);
            };
            var this_1 = this;
            for (var _i = 0, dataFilled_1 = dataFilled; _i < dataFilled_1.length; _i++) {
                var stopover = dataFilled_1[_i];
                _loop_1(stopover);
            }
        }
        var OnlyWhen = function (AC) {
            var stops = AC.get('stopover');
            if (stops.length > 1 && _this.route_type != 'multicity') {
                var duplicatesWhen = stops.value
                    .filter(function (cur) { return cur.when; })
                    .map(function (cur) { return cur.when; })
                    .sort()
                    .filter(function (cur, idx, arr) { return cur == arr[idx + 1]; });
                if (duplicatesWhen.length)
                    stops.setErrors({ DuplicatesWhen: true });
            }
            else {
                stops.setErrors(null);
                stops.clearValidators();
            }
            return null;
        };
        this.form.setValidators(OnlyWhen);
    };
    StopoverComponent.prototype.TAP_stopoverDisable = function () {
        return this.form.get('stopover').value.map(function (cur) { return ({ value: cur.when }); });
    };
    StopoverComponent.prototype.TAP_getLabel = function (item, type, idx) {
        if (type === void 0) { type = 'departure'; }
        if (idx === void 0) { idx = 0; }
        var label, infoSearchRoute;
        if (this.route_type == 'multicity') {
            infoSearchRoute = this.searchRoutes[idx];
        }
        else {
            infoSearchRoute = this.searchRoutes.find(function (v) { return v.arrival.code == item.arrival.code && v.departure.code == item.departure.code; });
            if (!infoSearchRoute)
                infoSearchRoute = item;
        }
        if (type == 'departure')
            label = infoSearchRoute.departure.location.city + " - " + infoSearchRoute.arrival.location.city;
        if (type == 'arrival')
            label = infoSearchRoute.arrival.location.city + " - " + infoSearchRoute.departure.location.city;
        return label;
    };
    StopoverComponent.prototype.TAP_closeSidebar = function () {
        this.sidebarService.closeSidebar();
    };
    StopoverComponent.prototype.TAP_changeInput = function (event, form) {
        form.setValue(event);
    };
    StopoverComponent.prototype.compareFn = function (c1, c2) {
        return c1 && c2 ? c1.id === c2.id : c1 === c2;
    };
    StopoverComponent.prototype.TAP_handleClose = function () {
        var _this = this;
        if (this.form.valid) {
            this.isLoading = true;
            var formValues_1 = this.form.value;
            var stopover = formValues_1.stopover.filter(function (cur) { return cur.active; });
            var newSearchRoutes = this.searchRoutes.map(function (cur, idx) {
                var c = { departure: Object.assign({}, cur.departure), arrival: Object.assign({}, cur.arrival), date: cur.date, id: cur.id };
                if (_this.route_type == 'multicity') {
                    c.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                    c.departure.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                }
                else {
                    c.departure.date = moment(formValues_1.searchroute[idx].departure, 'DD/MM/YYYY').toDate();
                    c.arrival.date = moment(formValues_1.searchroute[idx].arrival, 'DD/MM/YYYY').toDate();
                }
                return c;
            });
            this.isAlive = false;
            this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
            this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
            this.store.dispatch(new MiniIBEActions.PutStovers(stopover));
            this.sidebarService.showLoadingAndCloseSidebar();
            this.router.navigate(['/booking/flights-stopover']).then(function () {
                return _this.router.navigate(['.', { outlets: { sidebar: null } }], { replaceUrl: true });
            });
        }
    };
    StopoverComponent.prototype.TAP_showConfirmButton = function () {
        return true; // TODO
    };
    StopoverComponent.prototype.TAP_handleCountry = function (stopover) {
        if (stopover.value.active) {
            this.TAP_setRequiredValidators(stopover);
        }
        else {
            this.TAP_clearValidators(stopover);
        }
    };
    StopoverComponent.prototype.TAP_setRequiredValidators = function (form) {
        for (var key in form.controls) {
            form.get(key).setValidators(Validators.required);
            form.get(key).updateValueAndValidity();
        }
    };
    StopoverComponent.prototype.TAP_clearValidators = function (form) {
        for (var key in form.controls) {
            form.get(key).clearValidators();
            form.get(key).updateValueAndValidity();
        }
    };
    StopoverComponent.prototype.TAP_getStopovers = function (param) {
        var _this = this;
        this.bookingService.getStopovers(param.searchRoutes, param.routeType)
            .then(function (data) {
            _this.isLoading = false;
            if (data.length) {
                _this.stopovers.next(data);
                _this.createForm(data, param.searchRoutes, param.stopovers, param.routeType);
            }
            else {
                _this.isEligibleRoute = false;
            }
        });
    };
    StopoverComponent.prototype.TAP_disabled = function () {
        return this.route_type == 'multicity' ? true : false;
    };
    StopoverComponent.prototype.TAP_getNights = function (nights) {
        var departure = this.form.get('searchroute').at(0).get('departure').value;
        var arrival = this.form.get('searchroute').at(0).get('arrival').value;
        var range = moment.range(moment(departure, 'DD/MM/YYYY'), moment(arrival, 'DD/MM/YYYY'));
        var days = range.diff('days');
        if (days < 5)
            return nights.slice(0, days);
        return nights;
    };
    StopoverComponent.prototype.TAP_showError = function (control) {
        return this.triedToSubmit && !control.valid;
    };
    return StopoverComponent;
}());
export { StopoverComponent };
